import styled from "styled-components";
import {MainNavCanvasDefaultBox} from "./main-nav-canvas.default.box";

export const MainNavCanvasCasinoMrGreenBox = styled(MainNavCanvasDefaultBox)`
  background: linear-gradient(${props => props.theme.colors.background} 25%, ${props => props.theme.colors.backgroundDark} 75%);
  box-shadow: 5px 4px 10px rgba(0, 0, 0, 0.29), 13px 4px 40px rgba(0, 0, 0, 0.3);
`




